import React from "react";
import {
  FormControl,
  FormErrorMessage,
  FormLabel,
  Input,
  FormHelperText,
} from "@chakra-ui/react";
const TextField = ({ options, formik, id }) => {
  const styleClasses =
    options.styleClasses && options.styleClasses.length
      ? options.styleClasses.join(" ")
      : "";
  const textFieldErrors =
    Object.keys(formik.errors).length &&
    formik.errors.textField &&
    formik.errors.textField.length &&
    formik.errors.textField[id];
  const textFieldTouched =
    Object.keys(formik.touched).length &&
    formik.touched.textField &&
    formik.touched.textField.length &&
    formik.touched.textField[id];
  const hasError = textFieldTouched && textFieldErrors;
  const onChangeTextField = (e, id) => {
    const setValues = formik.setValues;
    const formikValues = formik.values;
    const textField = [...formik.values.textField];
    const currentValues = e.target.value;
    let newUpdateValue = true;
    Object.keys(formikValues.textField).some((field, i) => {
      Object.keys(formikValues.textField[i]) == e.target.name &&
        (formikValues.textField[i][e.target.name] = e.target.value);
      if (
        formikValues.textField.length - 1 == i &&
        Object.keys(formikValues.textField[i]) == e.target.name
      ) {
        newUpdateValue = false;
      }
      if (!newUpdateValue) {
        return;
      }
    });
    if (newUpdateValue) {
      const currentValuesWithId = {
        [e.target.name]: currentValues,
      };
      textField.push(currentValuesWithId);
    }
    setValues({ ...formikValues, textField });
  };

  return (
    <FormControl
      className={styleClasses}
      isInvalid={hasError ? true : false}
      mb="2"
      isRequired={options.isRequired}
    >
      {options.showLabel && (
        <FormLabel htmlFor="textField" fontSize="14px">
          {options.label}
        </FormLabel>
      )}

      <Input
        size="sm"
        name={`textField.${id}.name`}
        type="text"
        placeholder={options.placeholder}
        onChange={(e) => {
          onChangeTextField(e, id);
        }}
        value={
          formik.values && formik.values["textField"][`textField.${id}.name`]
        }
        // onChange={(e) =>
        //   formik.setFieldValue(`${e.target.name}`, e.target.value)
        // }
        // onChange={(e) => formik.setValues({ [e.target.name]: e.target.value })}
      />
      <FormHelperText>{options.helpText}</FormHelperText>
      {hasError ? (
        <FormErrorMessage>{formik.errors.textField}</FormErrorMessage>
      ) : null}
    </FormControl>
  );
};

export default TextField;
